import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import projects, { projectsSaga } from './projects';
import project, { projectSaga } from './project';
import projectComments, { projectCommentsSaga } from './projectComments';
import projectCosts, { projectCostsSaga } from './projectCosts';
import projectEstimates, { projectEstimatesSaga } from './projectEstimates';
import projectEstimate, { projectEstimateSaga } from './projectEstimate';
import projectFiles, { projectFilesSaga } from './projectFiles';
import projectTechFiles, { projectTechFilesSaga } from './projectTechFiles';
import projectTechs, { projectTechsSaga } from './projectTechs';
import reqTechs, { ReqTechsSaga } from './techReqs';
import planTechs, { PlanTechsSaga } from './techPlans';
import rsltTechs, { rsltTechsSaga } from './techRslts';
import tech, { techSaga } from './tech';
import techPlan, { techPlanSaga } from './techPlan';
import techRslt, { techRsltSaga } from './techRslt';
import techFiles, { techFilesSaga } from './techFiles';
import techMid, { techMidSaga } from './techMid';
import midTechs, { MidTechsSaga } from './techMids';

const techModule = combineReducers({
  projects,
  project,
  projectComments,
  projectCosts,
  projectEstimates,
  projectEstimate,
  projectFiles,
  projectTechFiles,
  projectTechs,
  tech,
  techFiles,
  techPlan,
  techMid,
  techRslt,
  reqTechs,
  planTechs,
  midTechs,
  rsltTechs,
});

export function* techModuleSaga() {
  yield all([
    projectsSaga(),
    projectSaga(),
    projectCommentsSaga(),
    projectCostsSaga(),
    projectEstimatesSaga(),
    projectEstimateSaga(),
    projectFilesSaga(),
    projectTechFilesSaga(),
    techSaga(),
    techPlanSaga(),
    techMidSaga(),
    projectTechsSaga(),
    techFilesSaga(),
    techRsltSaga(),
    ReqTechsSaga(),
    PlanTechsSaga(),
    MidTechsSaga(),
    rsltTechsSaga()
  ]);
}

export default techModule;
